import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ar',
    fullName: 'Arabic',
    nativeName: 'العربية',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "شيء مذهل قادم",
    landing_subtitle: "ArgVoid هو استوديو لتطوير التطبيقات والألعاب. ترقبوا، أشياء جديدة تأتي قريبا!",
    select_language: "اختر اللغة",
    search_placeholder: "بحث في اللغات...",
    terms_title: "شروط الخدمة",
    policy_title: "سياسة الخصوصية",
    cookies_title: "سياسة ملفات تعريف الارتباط",
    terms_content: `
        <strong>1. قبول الشروط</strong><br>
        من خلال الوصول إلى ArgVoid، يتم قبول شروط الخدمة هذه. إذا لم يتم الاتفاق على هذه الشروط، فلا ينبغي استخدام الخدمة.<br><br>

        <strong>2. استخدام المنصة</strong><br>
        يتم توفير ArgVoid وتطبيقاته "كما هي" لأغراض إعلامية وإبداعية. يجب استخدام الخدمة للأغراض القانونية فقط.<br><br>

        <strong>3. السلوك المحظور</strong><br>
        يُحظر تمامًا استغلال نقاط ضعف الموقع أو إرسال بريد عشوائي أو محاولة الوصول غير المصرح به إلى البنية التحتية.<br><br>

        <strong>4. إخلاء المسؤولية</strong><br>
        يجوز تعديل النظام الأساسي والخدمات في أي وقت دون إشعار مسبق. لا يتم تقديم أي ضمان بخصوص مدة تشغيل الخدمة أو توفرها.
    `,
    policy_content: `
        <strong>1. جمع المعلومات</strong><br>
        لا يتطلب النظام الأساسي مصادقة المستخدم أو إنشاء حساب في الوقت الحالي. لا يتم جمع أي معلومات تعريف شخصية (مثل الأسماء أو عناوين البريد الإلكتروني) بشكل نشط من الزوار.<br><br>

        <strong>2. بيانات الاستخدام</strong><br>
        يمكن جمع التحليلات الأساسية مجهولة المصدر لفهم حركة مرور الموقع وتحسين التطبيقات. لا ترتبط هذه البيانات بهويات المستخدمين الفردية.<br><br>

        <strong>3. خدمات الطرف الثالث</strong><br>
        يمكن الاستعانة بموفري الطرف الثالث لخدمات الاستضافة والتحليلات. تحكم ممارسات الخصوصية الخاصة بمقدمي الخدمات المعنيين البيانات المجهولة التي تتم معالجتها على البنية التحتية الخاصة بهم.<br><br>

        <strong>4. أمن البيانات</strong><br>
        يتم تنفيذ تدابير أمنية معقولة لحماية المنصة. ومع ذلك، لا توجد طريقة آمنة تمامًا للإرسال عبر الإنترنت.<br><br>
    `,
    cookies_content: `
        <strong>1. ما هي ملفات تعريف الارتباط والتخزين المحلي؟</strong><br>
        ملفات تعريف الارتباط والتخزين المحلي للمتصفح هي ملفات بيانات صغيرة مخزنة على الجهاز لتذكر تفضيلات التكوين عبر الزيارات.<br><br>

        <strong>2. غرض الاستخدام</strong><br>
        يتم استخدام Browser LocalStorage بشكل صارم لحفظ إعدادات التكوين، مثل:<br>
        - تفضيلات اللغة<br>
        - تكوين واجهة المستخدم (على سبيل المثال، إعدادات التخطيط أو السمة) <br>
        - ذاكرة التخزين المؤقت للتطبيق <br><br>

        <strong>3. لا يوجد تتبع</strong><br>
        لا يتم استخدام ملفات تعريف الارتباط والتخزين المحلي لأغراض الإعلان أو تتبع الجهات الخارجية. جميع البيانات المخزنة مخصصة فقط للوظيفة الأساسية للنظام.<br><br>

        <strong>4. التحكم</strong><br>
        يمكن مسح بيانات المتصفح في أي وقت من خلال إعدادات المتصفح، والتي ستعيد تعيين أي تكوينات محلية.
    `,
    cookie_consent_text: "نحن نستخدم ملفات تعريف الارتباط الأساسية لضمان عمل موقع الويب بشكل صحيح، مثل الحفاظ على جلسة العمل الخاصة بك نشطة، وحفظ تفضيلات اللغة الخاصة بك، والتكوينات المخصصة الأخرى.",
    read_policy: "اقرأ سياسة ملفات تعريف الارتباط",
    support_title: "اتصل بالدعم",
    support_subject_label: "موضوع",
    support_message_label: "رسالة",
    support_submit_button: "أرسل رسالة",
    support_hint: "ملاحظة: سيؤدي هذا إلى فتح تطبيق البريد الإلكتروني الافتراضي الخاص بك لإرسال الرسالة.",
    support_success_msg: "جارٍ فتح تطبيق البريد الإلكتروني...",
    support_error_msg: "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى في وقت لاحق.",
    explorer_title: "إكسبلورر",
    history_title: "تاريخ",
    animation_title: "الرسوم المتحركة",
    config_title: "إعدادات",
    tool_mouse: "تحديد (Ctrl+M)",
    tool_brush: "الفرشاة (Ctrl+B)",
    tool_brush_mode: "تبديل الوضع (ثابت/واضح)",
    tool_eraser: "الممحاة (Ctrl+E)",
    tool_brush_size: "ضبط حجم الفرشاة",
    tool_bucket: "تعبئة (Ctrl+F)",
    tool_eyedropper: "الشافطة",
    tool_grid: "الشبكة (Ctrl+Shift+B)",
    tool_rotate: "التدوير (Ctrl+Shift+R)",
    tool_flip_h: "الوجه H (Ctrl+Shift+H)",
    tool_flip_v: "الوجه V (Ctrl+Shift+V)",
    tool_transpose: "تبديل الوضع (Ctrl+Shift+T)",
    label_width: "عرض",
    label_height: "ارتفاع",
    label_frames: "عدد الإطارات",
    label_animation: "نمط الرسوم المتحركة",
    label_background_color: "لون الخلفية",
    label_interval: "فاصلة",
    tool_anim_config: "تكوين الرسوم المتحركة",
    label_new_width: "العرض الجديد",
    label_new_height: "الارتفاع الجديد",
    label_apply: "يتقدم",
    label_colors: "الألوان",
    label_size: "مقاس",
    label_tolerance: "تسامح",
    val_horizontal: "أفقي",
    val_vertical: "رَأسِيّ",
    val_sequence: "تسلسل",
    val_bounce: "ترتد",
    val_random: "عشوائي",
    val_solid: "صلب",
    val_clear: "واضح",
    action_add_sheet: "ورقة جديدة",
    action_import: "يستورد",
    action_export: "يصدّر",
    action_sort_projects: "نوع",
    sort_date_old: "الأقدم أولاً",
    sort_date_new: "الأحدث أولاً",
    sort_name_az: "الاسم (أ-ي)",
    sort_name_za: "الاسم (ي-أ)",
    action_new_sprite: "سبرايت جديد",
    action_new_project: "مشروع جديد",
    modal_save_all_title: "حفظ كافة التغييرات",
    modal_save_all_desc: "حدد الأصول المراد حفظها:",
    modal_save_selected: "حفظ المحدد",
    action_saved: "أنقذ",
    modal_create_sprite_title: "إنشاء كائن جديد",
    modal_create_project_title: "إنشاء مشروع جديد",
    modal_add_sheet_title: "إضافة ورقة جديدة",
    modal_rename_sheet_title: "إعادة تسمية الورقة",
    modal_rename_sprite_title: "إعادة تسمية العفريت",
    modal_delete_sprite_title: "حذف العفريت",
    modal_delete_project_title: "حذف المشروع",
    modal_delete_sheet_title: "حذف الورقة",
    placeholder_sprite_name: "اسم",
    placeholder_project_name: "اسم",
    placeholder_sheet_name: "اسم",
    placeholder_new_name: "اسم جديد",
    action_create: "يخلق",
    action_add: "يضيف",
    action_rename: "إعادة تسمية",
    action_duplicate: "ينسخ",
    action_delete: "يمسح",
    action_cancel: "يلغي",
    confirm_delete_sprite: "هل أنت متأكد أنك تريد حذف هذا الكائن؟",
    confirm_delete_project: "هل أنت متأكد أنك تريد حذف هذا المشروع؟ ستتم إزالة جميع النقوش المتحركة.",
    confirm_delete_sheet: "هل أنت متأكد أنك تريد حذف هذه الورقة؟",
    err_select_sprite: "الرجاء تحديد كائن أولاً.",
    err_select_project: "الرجاء تحديد المشروع أولا.",
    err_name_empty: "لا يمكن أن يكون الاسم فارغًا.",
    err_sprite_exists: "الكائن بهذا الاسم موجود بالفعل.",
    err_project_exists: "هناك مشروع بهذا الاسم موجود بالفعل.",
    err_no_content: "لا يوجد محتوى لحفظه.",
    err_no_changes: "لا توجد تغييرات للحفظ.",
    err_delete_last_sheet: "لا يمكن حذف الورقة الأخيرة.",
    err_extract_frames: "لا يمكن استخراج أية إطارات.",
    err_indexeddb: "فشل الحفظ محليا. قد لا يدعم متصفحك IndexedDB.",
    msg_upload_success: "تم التحميل بنجاح: {0}",
    msg_upload_failed: "فشل التحميل: {0}",
    msg_save_success: "تم الحفظ بنجاح.",
    msg_saving: "توفير...",
    msg_multi_save_result: "تم حفظ {0} من الأصول. {1} إخفاقات.",
    menu_title: "قائمة طعام",
    menu_save: "يحفظ",
    menu_save_all: "حفظ الكل",
    menu_support: "اتصل بالدعم",
    label_local_storage: "التخزين المحلي",
    label_sign_in: "تسجيل الدخول",
    modal_export_title: "تصدير العفريت",
    label_filename: "اسم الملف",
    label_format: "شكل",
    action_export_confirm: "يصدّر",
};

export default translations;
